import type { AD } from '../model/generic.model';

export type JobsTrafficSplitStatus = 'idle' | 'loading' | 'loaded';

export interface JobsTrafficSplitState {
    status: JobsTrafficSplitStatus;
    eligible: boolean;
}

export const initialJobsTrafficSplitState: JobsTrafficSplitState = {
    status: 'idle',
    eligible: false,
};

export const UPDATE_JOBS_TRAFFIC_SPLIT = 'UPDATE_JOBS_TRAFFIC_SPLIT';

export const updateJobsTrafficSplit: AD<
    typeof UPDATE_JOBS_TRAFFIC_SPLIT,
    Partial<JobsTrafficSplitState>
> = (payload) => ({
    type: UPDATE_JOBS_TRAFFIC_SPLIT,
    payload,
});

type JobsTrafficSplitRootState = {
    jobsTrafficSplit?: JobsTrafficSplitState;
};

export const fetchJobsTrafficSplitEligibility = () => async (dispatch, getState) => {
    const currentStatus = (getState() as JobsTrafficSplitRootState).jobsTrafficSplit?.status;

    if (currentStatus === 'loading' || currentStatus === 'loaded') {
        return;
    }

    dispatch(updateJobsTrafficSplit({ status: 'loading' }));

    try {
        const response = await fetch('/bff-api/jobs/experiment/check', {
            credentials: 'include',
            headers: {
                Accept: 'application/json',
            },
        });
        const data = response.ok ? await response.json() : null;

        dispatch(
            updateJobsTrafficSplit({
                status: 'loaded',
                eligible: data?.eligible === true,
            })
        );
    } catch {
        dispatch(
            updateJobsTrafficSplit({
                status: 'loaded',
                eligible: false,
            })
        );
    }
};

type JobsTrafficSplitAction = ReturnType<typeof updateJobsTrafficSplit>;

export default function jobsTrafficSplitReducer(
    state: JobsTrafficSplitState = initialJobsTrafficSplitState,
    action: JobsTrafficSplitAction
): JobsTrafficSplitState {
    if (action.type === UPDATE_JOBS_TRAFFIC_SPLIT) {
        return { ...state, ...action.payload };
    }

    return state;
}
